import { connect } from 'react-redux'
import { getUserId } from '@layers-frontend/commons/store/selectors/user'
import { successNotification } from '../../actions/notifications'
import CsatModal from '../../components/ModalComponents/CsatModal'

const mapStateToProps = state => ({
  userId: getUserId(state)
})

const mapDispatchToProps = {
  showSuccessNotification: successNotification
}

export default connect(mapStateToProps, mapDispatchToProps)(CsatModal)
